// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3r27L","fileBtn":"File_fileBtn__1fDvS","closeBtn":"File_closeBtn__1lq1d","fileSelected":"File_fileSelected__1D6R2","disabled":"File_disabled__1ohGx"};